import { render, staticRenderFns } from "./OperationNotesDialog.vue?vue&type=template&id=954bbb58"
import script from "./OperationNotesDialog.vue?vue&type=script&lang=ts"
export * from "./OperationNotesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports